const Api = {
  install(Vue, options) {
    Vue.prototype.$api = {
      comments: {
        store(comment) {
          return axios.post(`/comments`, comment)
        },
        delete(id) {
          return axios.delete(`/comments/${id}`)
        },
      },
      replies: {
        index(id) {
          return axios.post(`/comment/${id}/replies`)
        },
        store(id, reply) {
          return axios.post(`/comment/${id}/reply`, reply)
        },
        delete(id) {
          return axios.delete(`/replies/${id}`)
        },
      },
      votes: {
        store(vote) {
          return axios.post('/vote', vote)
        },
      },
      getStudent() {
        return axios.post('/student')
      },
      checkTransactionStatus(transaction) {
        return axios.post(`/transaction/${transaction}/pending`)
      },
      onePageCheckoutRegister(course, data) {
        return axios.post(`/${course}/onepagecheckoutregister`, data)
      },
      onePageCheckout(course, data) {
        return axios.post(`/${course}/onepagecheckout`, data)
      },
      onePageCheckoutSubscriptionRegister(data) {
        return axios.post(`/subscribe/checkout/register`, data)
      },
      onePageCheckoutSubscription(data) {
        return axios.post(`/subscribe/checkout`, data)
      },
      onePageCheckoutSubscriptionStripe(data) {
        return axios.post(`/stripe/subscribe/checkout`, data)
      },
      back() {
        return '/'
      },
      login(credentials) {
        return axios.post(`/checkout/login`, credentials)
      },
      register(credentials) {
        return axios.post(`/checkout/register`, credentials)
      },
      fetchLecture(lectureId) {
        return axios.post(`/lecture/${lectureId}/watch`)
      },
      editNote(lectureId, note) {
        return axios.post(`/lecture/${lectureId}/notes`, { note })
      },
      starLecture(lectureId) {
        return axios.post(`/lecture/${lectureId}/star`)
      },
      completeLecture(lectureId) {
        return axios.post(`/lecture/${lectureId}/complete`)
      },
      checkPromoCode(data) {
        return axios.post('/json/promo-code', data)
      },
    }
  },
}

export default Api